import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod/v4";

export const getProductsWithoutBinMetafield = unaryRpc({
  name: "getProductsWithoutBinMetafield" as const,
  input: z.object({ identifiers: z.array(z.string()) }),
  output: z.object({ identifiers: z.array(z.string()) }),
});
